/**
 * Joy Loyalty — Tier Card Swiper
 *
 * Inject UI hiển thị tier vào hero banner, layout horizontal:
 * [icon] [tier name / membership level] [points / available points] ... [activities btn] [rewards btn]
 * ───────── progress bar ─────────
 * Spend $X to NextTier                                                  pct%
 *
 * Swipe trái/phải để preview tier khác. Data lấy từ joyInstance.customer() + tiers().
 */

(function () {
  'use strict';

  // ===== CONFIG =====
  var CONFIG = {
    bannerSelector: '.hero-banner',
    tierLabel: 'Membership Level',
    pointsLabel: 'Available points',
    requiredLabel: 'Required points',
    activitiesText: 'MY ACTIVITIES',
    rewardsText: 'MY REWARDS',
    activitiesUrl: '#joy-activities',
    rewardsUrl: '#joy-rewards',
    currencySymbol: '$',
    pointPerCurrency: 1,           // dollars-per-point để tính "Spend $X to..."
    swipeThreshold: 50,
    joyWaitTimeoutMs: 10000,
    debug: false,

    // Palette mặc định nếu tier không có sẵn màu
    accentColor: '#B86E4B',
    progressTrackColor: 'rgba(120, 95, 77, 0.18)',
    textPrimary: '#3A2618',
    textSecondary: '#9C8B7A',
    buttonBg: '#2E2E2E',
    buttonBgHover: '#1A1A1A',
    buttonColor: '#FFFFFF'
  };
  // ==================

  var STYLE_ID = 'joy-tier-card-swiper-style';
  var ROOT_CLASS = 'joy-tier-swiper';
  var dataCache = { customer: null, tiers: null, loaded: false, loading: null };

  function log() { if (CONFIG.debug) console.log.apply(console, ['[joy-tier-swiper]'].concat([].slice.call(arguments))); }

  function waitForJoy() {
    return new Promise(function (resolve, reject) {
      if (window.joyInstance && typeof window.joyInstance.customer === 'function') return resolve(window.joyInstance);
      var start = Date.now();
      var iv = setInterval(function () {
        if (window.joyInstance && typeof window.joyInstance.customer === 'function') {
          clearInterval(iv); resolve(window.joyInstance);
        } else if (Date.now() - start > CONFIG.joyWaitTimeoutMs) {
          clearInterval(iv); reject(new Error('joyInstance not available'));
        }
      }, 150);
    });
  }

  function callFirstAvailable(joy, names) {
    for (var i = 0; i < names.length; i++) {
      if (typeof joy[names[i]] === 'function') {
        try { return Promise.resolve(joy[names[i]]()).catch(function () { return null; }); }
        catch (e) { /* next */ }
      }
    }
    return Promise.resolve(null);
  }

  function loadData() {
    if (dataCache.loaded) return Promise.resolve(dataCache);
    if (dataCache.loading) return dataCache.loading;

    dataCache.loading = waitForJoy()
      .then(function (joy) {
        return Promise.all([
          callFirstAvailable(joy, ['customer']),
          callFirstAvailable(joy, ['tiers', 'vipTiers', 'viptiers', 'getTiers', 'getVipTiers'])
        ]);
      })
      .then(function (results) {
        dataCache.customer = results[0] || null;
        var t = results[1];
        dataCache.tiers = Array.isArray(t) ? t : (t && t.data) || [];
        dataCache.loaded = true;
        return dataCache;
      })
      .catch(function () { dataCache.loaded = true; return dataCache; });

    return dataCache.loading;
  }

  function sortTiers(tiers) {
    return tiers.slice().sort(function (a, b) {
      var pa = typeof a.position === 'number' ? a.position : null;
      var pb = typeof b.position === 'number' ? b.position : null;
      if (pa !== null && pb !== null) return pa - pb;
      return (Number(a.targetPoint) || 0) - (Number(b.targetPoint) || 0);
    });
  }

  function findCurrentTierIndex(customer, sorted) {
    if (customer && customer.tierId) {
      var idx = sorted.findIndex(function (t) { return t.id === customer.tierId; });
      if (idx >= 0) return idx;
    }
    var points = customer ? (customer.tierPoint || customer.point || 0) : 0;
    var current = 0;
    for (var i = 0; i < sorted.length; i++) {
      if ((Number(sorted[i].targetPoint) || 0) <= points) current = i;
      else break;
    }
    return current;
  }

  function injectStyleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var c = CONFIG;
    var css = `
      .${ROOT_CLASS} {
        position: relative;
        width: 100%;
        padding: 16px 20px;
        overflow: hidden;
        font-family: inherit;
        box-sizing: border-box;
        user-select: none;
      }
      .${ROOT_CLASS}__viewport { overflow: hidden; }
      .${ROOT_CLASS}__track {
        display: flex;
        transition: transform .4s cubic-bezier(.2,.7,.3,1);
        will-change: transform;
        touch-action: pan-y;
      }
      .${ROOT_CLASS}__slide {
        flex: 0 0 100%;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 4px 2px;
        box-sizing: border-box;
      }
      .${ROOT_CLASS}__row {
        display: flex;
        align-items: center;
        gap: 24px;
        flex-wrap: wrap;
      }
      .${ROOT_CLASS}__icon {
        width: 56px; height: 56px;
        flex-shrink: 0;
        object-fit: contain;
      }
      .${ROOT_CLASS}__info { display: flex; flex-direction: column; line-height: 1.2; min-width: 0; }
      .${ROOT_CLASS}__name {
        font-size: 18px;
        font-weight: 700;
        color: ${c.textPrimary};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .${ROOT_CLASS}__sublabel {
        font-size: 12px;
        color: ${c.textSecondary};
        margin-top: 4px;
      }
      .${ROOT_CLASS}__points-value {
        font-size: 18px;
        font-weight: 700;
        color: ${c.textPrimary};
      }
      .${ROOT_CLASS}__buttons {
        margin-left: auto;
        display: flex;
        gap: 8px;
        flex-shrink: 0;
      }
      .${ROOT_CLASS}__btn {
        background: ${c.buttonBg};
        color: ${c.buttonColor};
        border: none;
        padding: 10px 18px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 1.2px;
        cursor: pointer;
        text-decoration: none;
        text-transform: uppercase;
        white-space: nowrap;
        transition: background .2s;
      }
      .${ROOT_CLASS}__btn:hover { background: ${c.buttonBgHover}; }
      .${ROOT_CLASS}__progress {
        position: relative;
        height: 4px;
        background: ${c.progressTrackColor};
        border-radius: 999px;
        overflow: hidden;
      }
      .${ROOT_CLASS}__progress-bar {
        position: absolute;
        top: 0; left: 0; bottom: 0;
        background: ${c.accentColor};
        border-radius: 999px;
        transition: width .5s ease;
      }
      .${ROOT_CLASS}__footer {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        color: ${c.textPrimary};
        font-weight: 600;
      }
      .${ROOT_CLASS}__dots {
        display: flex;
        gap: 6px;
        justify-content: center;
        margin-top: 12px;
      }
      .${ROOT_CLASS}__dot {
        width: 8px; height: 8px;
        border-radius: 50%;
        background: ${c.progressTrackColor};
        cursor: pointer;
        transition: all .25s ease;
      }
      .${ROOT_CLASS}__dot.is-active {
        background: ${c.accentColor};
        width: 22px;
        border-radius: 4px;
      }
      @media (max-width: 720px) {
        .${ROOT_CLASS}__row { gap: 14px; }
        .${ROOT_CLASS}__buttons { margin-left: 0; width: 100%; }
        .${ROOT_CLASS}__btn { flex: 1; text-align: center; }
      }
    `;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildSlide(tier, index, customer, sorted, currentIdx) {
    var slide = document.createElement('div');
    slide.className = ROOT_CLASS + '__slide';
    slide.setAttribute('data-tier-id', tier.id || '');

    var isCurrent = index === currentIdx;
    var customerPoints = customer ? (customer.tierPoint || customer.point || 0) : 0;
    var nextTier = sorted[index + 1] || null;

    var pct = 0;
    var footerLeft = '';
    var footerRight = '';

    if (isCurrent) {
      if (nextTier) {
        var from = Number(tier.targetPoint) || 0;
        var to = Number(nextTier.targetPoint) || 0;
        if (to > from) pct = Math.max(0, Math.min(100, ((customerPoints - from) / (to - from)) * 100));
        var pointsNeeded = Math.max(0, to - customerPoints);
        var dollarsNeeded = Math.ceil(pointsNeeded / CONFIG.pointPerCurrency);
        footerLeft = 'Spend ' + CONFIG.currencySymbol + dollarsNeeded + ' to ' + (nextTier.name || 'next tier');
        footerRight = Math.round(pct) + '%';
      } else {
        pct = 100;
        footerLeft = 'Top tier reached';
        footerRight = '✓';
      }
    } else if (index < currentIdx) {
      pct = 100;
      footerLeft = 'Unlocked';
      footerRight = '✓';
    } else {
      // future tier preview
      var target = Number(tier.targetPoint) || 0;
      var gap = Math.max(0, target - customerPoints);
      var dollarsToThis = Math.ceil(gap / CONFIG.pointPerCurrency);
      pct = customerPoints >= target ? 100 : (target > 0 ? Math.min(100, (customerPoints / target) * 100) : 0);
      footerLeft = 'Spend ' + CONFIG.currencySymbol + dollarsToThis + ' to ' + (tier.name || 'this tier');
      footerRight = Math.round(pct) + '%';
    }

    var displayPoints = isCurrent ? customerPoints : (Number(tier.targetPoint) || 0);
    var pointsSub = isCurrent ? CONFIG.pointsLabel : CONFIG.requiredLabel;
    var iconUrl = tier.iconCustom || tier.imageBlock || '';

    slide.innerHTML =
      '<div class="' + ROOT_CLASS + '__row">' +
      (iconUrl ? '<img class="' + ROOT_CLASS + '__icon" src="' + escapeHtml(iconUrl) + '" alt="' + escapeHtml(tier.name) + '">' : '') +
      '<div class="' + ROOT_CLASS + '__info">' +
      '<span class="' + ROOT_CLASS + '__name">' + escapeHtml(tier.name || 'Tier') + '</span>' +
      '<span class="' + ROOT_CLASS + '__sublabel">' + escapeHtml(CONFIG.tierLabel) + '</span>' +
      '</div>' +
      '<div class="' + ROOT_CLASS + '__info">' +
      '<span class="' + ROOT_CLASS + '__points-value">' + displayPoints + '</span>' +
      '<span class="' + ROOT_CLASS + '__sublabel">' + escapeHtml(pointsSub) + '</span>' +
      '</div>' +
      '<div class="' + ROOT_CLASS + '__buttons">' +
      '<a class="' + ROOT_CLASS + '__btn" href="' + escapeHtml(CONFIG.activitiesUrl) + '">' + escapeHtml(CONFIG.activitiesText) + '</a>' +
      '<a class="' + ROOT_CLASS + '__btn" href="' + escapeHtml(CONFIG.rewardsUrl) + '">' + escapeHtml(CONFIG.rewardsText) + '</a>' +
      '</div>' +
      '</div>' +
      '<div class="' + ROOT_CLASS + '__progress">' +
      '<div class="' + ROOT_CLASS + '__progress-bar" style="width:' + pct + '%;"></div>' +
      '</div>' +
      '<div class="' + ROOT_CLASS + '__footer">' +
      '<span>' + escapeHtml(footerLeft) + '</span>' +
      '<span>' + escapeHtml(footerRight) + '</span>' +
      '</div>';

    slide.querySelectorAll('.' + ROOT_CLASS + '__btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    return slide;
  }
  console.log(CONFIG,123123);
  function buildSwiper(customer, sorted) {
    var root = document.createElement('div');
    root.className = ROOT_CLASS;

    var viewport = document.createElement('div');
    viewport.className = ROOT_CLASS + '__viewport';
    var track = document.createElement('div');
    track.className = ROOT_CLASS + '__track';
    viewport.appendChild(track);
    root.appendChild(viewport);

    var currentIdx = findCurrentTierIndex(customer, sorted);
    sorted.forEach(function (tier, idx) {
      track.appendChild(buildSlide(tier, idx, customer, sorted, currentIdx));
    });

    var dots = document.createElement('div');
    dots.className = ROOT_CLASS + '__dots';
    sorted.forEach(function (_, idx) {
      var dot = document.createElement('span');
      dot.className = ROOT_CLASS + '__dot';
      if (idx === currentIdx) dot.classList.add('is-active');
      dot.addEventListener('click', function () { goTo(root, idx, sorted.length); });
      dots.appendChild(dot);
    });
    root.appendChild(dots);

    root._state = { currentIndex: currentIdx, total: sorted.length };
    attachSwipe(root, viewport, sorted.length);

    // Snap initial position (no animation on first frame)
    requestAnimationFrame(function () {
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (currentIdx * 100) + '%)';
      requestAnimationFrame(function () { track.style.transition = ''; });
    });

    return root;
  }

  function goTo(root, index, total) {
    index = Math.max(0, Math.min(total - 1, index));
    root._state.currentIndex = index;
    var track = root.querySelector('.' + ROOT_CLASS + '__track');
    if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';
    var dots = root.querySelectorAll('.' + ROOT_CLASS + '__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
  }

  function attachSwipe(root, viewport, total) {
    var startX = 0, currentX = 0, dragging = false, startTime = 0;
    var track = viewport.querySelector('.' + ROOT_CLASS + '__track');

    function onStart(x) {
      startX = currentX = x;
      dragging = true;
      startTime = Date.now();
      track.style.transition = 'none';
    }
    function onMove(x) {
      if (!dragging) return;
      currentX = x;
      var dx = currentX - startX;
      var slideWidth = viewport.clientWidth;
      var baseOffset = -root._state.currentIndex * slideWidth;
      track.style.transform = 'translateX(' + (baseOffset + dx) + 'px)';
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var dx = currentX - startX;
      var elapsed = Date.now() - startTime;
      var isQuickFlick = elapsed < 250 && Math.abs(dx) > 20;
      var slideWidth = viewport.clientWidth;
      var threshold = Math.min(CONFIG.swipeThreshold, slideWidth * 0.2);

      if (dx < -threshold || (isQuickFlick && dx < 0)) {
        goTo(root, root._state.currentIndex + 1, total);
      } else if (dx > threshold || (isQuickFlick && dx > 0)) {
        goTo(root, root._state.currentIndex - 1, total);
      } else {
        goTo(root, root._state.currentIndex, total); // snap back
      }
    }

    viewport.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX); }, { passive: true });
    viewport.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    viewport.addEventListener('touchend', onEnd);
    viewport.addEventListener('touchcancel', onEnd);

    viewport.addEventListener('mousedown', function (e) {
      // bỏ qua click vào button/link để không bị drag khi user muốn click
      if (e.target.closest('a, button')) return;
      e.preventDefault();
      onStart(e.clientX);
    });
    window.addEventListener('mousemove', function (e) { if (dragging) onMove(e.clientX); });
    window.addEventListener('mouseup', onEnd);
  }

  function attachToBanner(banner, customer, sorted) {
    // Remove old instance nếu có
    var old = banner.querySelector('.' + ROOT_CLASS);
    if (old) old.remove();

    var swiper = buildSwiper(customer, sorted);
    banner.appendChild(swiper);
    log('attached', sorted.length, 'tiers');
  }

  function applyAll() {
    var banners = document.querySelectorAll(CONFIG.bannerSelector);
    if (!banners.length) return;

    injectStyleOnce();

    loadData().then(function (data) {
      if (!data.tiers || !data.tiers.length) return log('no tiers data');
      var sorted = sortTiers(data.tiers);
      banners.forEach(function (b) { attachToBanner(b, data.customer, sorted); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches(CONFIG.bannerSelector)) ||
          (node.querySelector && node.querySelector(CONFIG.bannerSelector))) {
          applyAll();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.joyTierCardSwiper = { apply: applyAll, cache: dataCache, config: CONFIG, goTo: goTo };
})();
